import React, { type ComponentPropsWithRef, type FC, forwardRef, type PropsWithChildren } from 'react';

import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

export type ContainerTagsType = 'div' | 'section' | 'header' | 'main';

export interface ContainerProps extends ComponentPropsWithRef<'div'> {
  /** Sets the HTML tag for the Container component. */
  as?: ContainerTagsType;
  /** Allows the component to get additional styles. */
  className?: string;
  /** Adds additional padding to the Container at maxWidth breakpoint. */
  extraPadding?: number;
  /** Sets the HTML id for the Container. */
  id?: string;
}

const StyledContainer: FC<PropsWithChildren<ContainerProps>> = styled('div', {
  shouldForwardProp: isPropValid,
})<ContainerProps>(({ extraPadding = 0, theme }) => ({
  label: 'container',
  display: 'block',
  position: 'relative',
  maxWidth: '90rem',
  width: '100%',
  margin: '0 auto',
  height: '100%',
  WebkitFontSmoothing: 'antialiased',
  justifyContent: 'space-between',
  paddingRight: '1.875rem',
  paddingLeft: '1.875rem',
  [theme.breakpoints.bp900.min]: {
    paddingRight: '3.75rem',
    paddingLeft: '3.75rem',
  },
  [theme.breakpoints.bp1024.min]: {
    paddingRight: '1.75rem',
    paddingLeft: '1.75rem',
  },
  [theme.breakpoints.bp1220.min]: {
    paddingRight: '3.75rem',
    paddingLeft: '3.75rem',
  },
  [theme.breakpoints.bp1440.min]: {
    paddingRight: `${7.5 + extraPadding}rem`,
    paddingLeft: `${7.5 + extraPadding}rem`,
  },
}));

const Container = forwardRef<HTMLDivElement, ContainerProps>(({ className, ...rest }, forwardedRef) => (
  <StyledContainer {...rest} ref={forwardedRef} className={className} />
));

export { Container };
export default Container;
